import { render } from "./Next2.vue?vue&type=template&id=7a839344"
import script from "./Next2.vue?vue&type=script&lang=js"
export * from "./Next2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__